import { render, staticRenderFns } from "./Test4.vue?vue&type=template&id=968e17f8&scoped=true&"
import script from "./Test4.vue?vue&type=script&lang=js&"
export * from "./Test4.vue?vue&type=script&lang=js&"
import style0 from "./Test4.vue?vue&type=style&index=0&id=968e17f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968e17f8",
  null
  
)

export default component.exports